import React from "react";
import { resolveStatusColumn } from "@helpers/helpers";
import LegendComponent from "@components/LegendComponent";
import BadgeComponent from "@components/BadgeComponent";
import ButtonComponent from "@components/ButtonComponent";
import { FIRST_INDEX } from "./constants";
import { ZERO_VALUE } from "@utils/constants";

export const getColumnsConfig = (setOpenConfirmation, actions, translate) => {
  const legendData = [];

  return [
    {
      accessorKey: "DataAcquisitionStatusTag",
      header: translate("data-acquisitions.columns.Status"),
      headerHelper: () => {
        return (
          <LegendComponent
            data={legendData}
            dataToHide={["COMPLETED", "FAILED"]}
          />
        );
      },
      size: 50,
      sortable: true,
      canFilter: false,
      alignment: "left",
      hideCopy: true,
      processFilterValue: (value, row) => {
        return row.DataAcquisitionStatusTag;
      },
      processFilterKey: (value, row) => {
        return "DataAcquisitionStatusTag";
      },
      cell: ({ row }) => {
        return resolveStatusColumn(
          row.original.DataAcquisitionStatusName,
          row.original.DataAcquisitionStatusTag,
          ["INPROGRESS"],
          null,
          row.original.DataAcquisitionInstanceStatusTag
        );
      },
    },
    {
      accessorKey: "DataAcquisitionName",
      header: translate("data-acquisitions.columns.DataAcquisitionName"),
      canFilter: false,
      isMultiple: false,
      sortable: true,
      size: 150,
      alignment: "left",
      processFilterValue: (value, row) => {
        return row.DataAcquisitionTag;
      },
      processFilterKey: (value, row) => {
        return "DataAcquisitionTag";
      },
    },
    {
      accessorKey: "IsScheduled",
      header: translate("data-acquisitions.columns.Schedule"),
      size: 230,
      sortable: false,
      canPin: false,
      alignment: "left",
      cell: ({ row }) => {
        return (
          <span
            className={`rounded-full flex items-center justify-start gap-1 w-full font-normal text-sm border border-r-10 border-transparent `}
          >
            <div className="flex flex-col gap-2">
              {row.original.PeriodicityName}{" "}
              <div className="flex gap-2 flex-wrap whitespace-nowrap">
                {row.original.AllowManualTrigger && (
                  <BadgeComponent
                    text={translate("data-acquisitions.legend.onDemand")}
                    color="blue"
                  />
                )}
                {row.original.AllowFileDrop && (
                  <BadgeComponent
                    text={translate("data-acquisitions.legend.manual")}
                    color="green"
                  />
                )}
              </div>
            </div>
          </span>
        );
      },
    },
    {
      accessorKey: "NextAcquisition",
      header: translate("data-acquisitions.columns.NextAcquisition"),
      size: 140,
      sortable: true,
      canFilter: false,
      splitCellValue: "T",
      hideCopy: true,
    },
    {
      accessorKey: "LastSuccessfulAcquisition",
      header: translate("data-acquisitions.columns.LastSuccessfulAcquisition"),
      size: 140,
      sortable: true,
      canFilter: false,
      splitCellValue: "T",
      hideCopy: true,
    },
    {
      accessorKey: "LastDuration",
      header: translate("data-acquisitions.columns.LastDuration"),
      size: 120,
      sortable: true,
      canFilter: false,
      hideCopy: true,
    },
    {
      accessorKey: "Statistics",
      header: translate("data-acquisitions.columns.Statistics"),
      size: 160,
      canFilter: false,
      processFilterKey: (value, row) => {
        return "FailuresPercentage";
      },
      processFilterValue: (value) => {
        return value[FIRST_INDEX].StatisticValues.find(
          (element) => element.Key === "FailuresPercentage"
        ).Value;
      },
      cell: ({ row }) => {
        const percentage =
          (!!row.original.Statistics[FIRST_INDEX] &&
            row.original.Statistics[FIRST_INDEX].StatisticValues.find(
              (element) => element.Key === "FailuresPercentage"
            ).Value) ||
          "0.00%";
        return (
          <div
            className={`w-[90%] rounded-full flex items-end justify-center gap-1  font-normal text-sm border border-r-10 border-transparent `}
          >
            <div className="flex w-full flex-col gap-2 items-center">
              <div className="w-full relative bg-gray-200 rounded-full dark:bg-gray-600 overflow-hidden">
                <div
                  className="bg-primary-400 absolute h-full text-xs font-medium text-white text-center p-0.5 leading-none rounded-full"
                  style={{ width: `${percentage}` }}
                >
                  {" "}
                </div>
                <div className="relative text-white z-2">{percentage}</div>
              </div>
              {percentage !== ZERO_VALUE && percentage !== "0.00%" && (
                <ButtonComponent
                  withoutborder
                  type="reset"
                  onClick={() =>
                    setOpenConfirmation(actions["RESET_PERCENTAGE"](row))
                  }
                  ref={null}
                  icon={null}
                  text={translate("data-acquisitions.buttons.reset")}
                  minwidth="min-w-max"
                  size="sm"
                  noTextSwap={true}
                  width="max"
                />
              )}
            </div>
          </div>
        );
      },
    },
  ];
};
